import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "es-select-institute col" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = { class: "col-0-6 colend mright-04" }
const _hoisted_4 = { class: "main-m font-m" }
const _hoisted_5 = { class: "row gap-06" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "row w-full"
}
const _hoisted_8 = { class: "col-0-6 colend mright-04" }
const _hoisted_9 = { class: "main-m font-m align-r" }
const _hoisted_10 = { class: "row gap-06" }
const _hoisted_11 = ["src"]

import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { PersonLightResponse, SettingsApi } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { ApiError, ItemSelect } from '@/models/share.model';
import { useAppUserStore } from '@/stores/appUser';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import Select from 'primevue/select';
import SharedService from '@/services/SharedService';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'esSelectInstitute',
  props: {
    withHealthPro: { type: Boolean, default: false },
    hasOwnerAgendaPermission: { type: Boolean, default: false }
  },
  emits: ['selectInstitute', 'selectHealthPro'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const appUserStore = useAppUserStore();
const { t } = useI18n();
const toast = useToast();

const settingsApi = new SettingsApi(medServerApiConfig);

let selectedInstitute = ref<ItemSelect>(undefined);
const healthProList = ref< PersonLightResponse[]>([]);
const selectedHealthPro = ref<PersonLightResponse>(undefined);

const emits = __emit

const transformToItemSelect = (dataToTransform: any): ItemSelect => {
    return {
        id: dataToTransform.instituteWithRoleId,
        label: dataToTransform.instituteName
    }
};

const currInstitute = computed((): ItemSelect => {
  if (!appUserStore.currentHealthGroupMembership) {return null;}
  const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole;
  return transformToItemSelect(currentIwr);
});

const currentPerson = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr
});

const healthGroupMemberships = computed(() => {
  return appUserStore.currentAppUserData.healthGroupMemberships
            .map(healthGroup => transformToItemSelect(healthGroup.instituteWithRole));
});

const selectInstitute = (selectedData: ItemSelect) => {
    selectedInstitute.value = selectedData;
    emits('selectInstitute', selectedInstitute.value);
};
const selectHealthPro = (selectedData: PersonLightResponse) => {
  selectedHealthPro.value = selectedData;
  emits('selectHealthPro', selectedHealthPro.value);
}

const getHealthProForAdminPlanningByInstitute = () => {
  if (selectedInstitute.value?.id) {
    settingsApi.getHealthProForAdminPlanningByInstitute({instituteId: selectedInstitute.value.id}).then((result: PersonLightResponse[]) => {
      healthProList.value = result;

      if (currentPerson.value && props.hasOwnerAgendaPermission) {
        healthProList.value.unshift({
          id: currentPerson.value.personWithRoleId,
          firstname: currentPerson.value.firstName,
          lastname: currentPerson.value.lastName + t('patient.delegate.me')
        });
      }

      selectHealthPro(healthProList.value[0]);

    }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });
    });
  }
};

watch(
  () => currInstitute.value,
  (newCurrInstitute: ItemSelect) => {
    if (newCurrInstitute) {
        selectedInstitute.value = newCurrInstitute;
    }
  },
  { deep: true }
);

watch(
  () => appUserStore.refreshHealthProInstitute,
  () => {
    if (appUserStore.refreshHealthProInstitute) {
      getHealthProForAdminPlanningByInstitute();
      appUserStore.setRefreshHealthProInstitute(false);
    }
  }
);

onMounted(async () => {
  selectInstitute(currInstitute.value);

  if (props.withHealthPro) {
      await getHealthProForAdminPlanningByInstitute();
    }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)('settings.label.select.institutes')), 1)
      ]),
      _createVNode(_unref(Select), {
        modelValue: _unref(selectedInstitute),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedInstitute) ? (selectedInstitute).value = $event : selectedInstitute = $event)),
        options: healthGroupMemberships.value,
        onValueChange: _cache[1] || (_cache[1] = ($event: any) => (selectInstitute($event))),
        size: "small",
        class: "w-full",
        optionLabel: "label",
        filter: ""
      }, _createSlots({ _: 2 }, [
        (_unref(selectedInstitute))
          ? {
              name: "value",
              fn: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _unref(SharedService).getIcon('building-2', true, 'shareIcons'),
                    class: "img-grey"
                  }, null, 8, _hoisted_6),
                  _createTextVNode(" " + _toDisplayString(slotProps.value.label), 1)
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "options"])
    ]),
    (_ctx.withHealthPro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('settings.label.select.healthpros')), 1)
          ]),
          _createVNode(_unref(Select), {
            modelValue: selectedHealthPro.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedHealthPro).value = $event)),
            onValueChange: _cache[3] || (_cache[3] = ($event: any) => (selectHealthPro($event))),
            options: healthProList.value,
            size: "small",
            class: "w-full"
          }, _createSlots({
            option: _withCtx((slotProps) => [
              _createElementVNode("span", {
                class: _normalizeClass({'font-bold-700': slotProps.option.id === currentPerson.value.id})
              }, _toDisplayString(_unref(PersonService).formatName(slotProps.option.lastname, slotProps.option.firstname)), 3)
            ]),
            _: 2
          }, [
            (selectedHealthPro.value)
              ? {
                  name: "value",
                  fn: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: _unref(SharedService).getIcon('person', true, 'shareIcons'),
                        class: "img-grey"
                      }, null, 8, _hoisted_11),
                      _createTextVNode(" " + _toDisplayString(_unref(PersonService).formatName(slotProps.value.lastname, slotProps.value.firstname)), 1)
                    ])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "options"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})